import { useEffect } from 'react';

export const Redirect = () => {
	useEffect(() => {
		window.location.href = import.meta.env.VITE_REDIRECT_URL;
	}, []);
	return null;
};
